import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getVerificationList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        verId: item.verId ? item.verId : '-',
        verify: item.verify ? item.verify : '-',
        feedback: item.feedback ? item.feedback : '-',
        verMonth: item.verMonth ? item.verMonth : '-',
        verWeek: item.verWeek ? item.verWeek.split('T')[0] : '-',
        providerName: item.provider?.name ? item.provider?.name : '-',
        cbpId: item.provider?.cbpId ? item.provider?.cbpId : '-',
        dateSent: item.dateSent
          ? moment(item.dateSent).format(dateFormat).split('T')[0]
          : '-',
        rcvd: item.rcvd,
        dateRcvd: item.dateRcvd
          ? moment(item.dateRcvd).format(dateFormat).split('T')[0]
          : '-',
        verificationContactName: item.provider?.verificationContact?.name
          ? item.provider?.verificationContact?.name
          : '-',
        phone: item.provider?.verificationContact?.phone
          ? item.provider?.verificationContact?.phone
          : '-',
        fax: item.provider?.verificationContact?.fax
          ? item.provider?.verificationContact?.fax
          : '-',
      })),
    };
  }).catch((e) => console.log(e));
};


